import { StyleSheet } from 'aphrodite/no-important';

import {
  spacers,
  palettes,
  fonts,
} from '../../node_modules/@trainline/depot-web/lib/css/themes/trainline';

export default StyleSheet.create({
  profileStatusContainer: {
    marginBottom: spacers.dp_s24,
    display: 'flex',
    padding: `${spacers.dp_s12} ${spacers.dp_s24}`,
    border: `1px solid ${palettes.dp_app_border_base}`,
    backgroundColor: palettes.dp_app_backdrop_base,
    borderRadius: spacers.dp_s8,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  statusContainer: {
    display: 'flex',
    gap: spacers.dp_s4,
  },
  statusTitle: {
    fontSize: spacers.dp_s16,
    fontWeight: fonts.dp_font_weight_semibold,
    color: palettes.dp_app_text_base,
  },
  statusText: {
    fontSize: spacers.dp_s16,
    fontWeight: 'normal',
    color: palettes.dp_app_text_positive,
  },
  menuItem: {
    color: palettes.dp_app_text_base,
  },
});
